module.exports = __webpack_public_path__ + "static/media/td.f37a395c.svg";